import { useState } from "react";
import {
	PaymentSentSearch,
	type PaymentSentSearchFilters,
	PaymentSentTable,
} from "./components";

function PaymentSent({ relationId }: { relationId?: string }) {
	const [filters, setFilters] = useState<PaymentSentSearchFilters>({});

	return (
		<div className="flex flex-col gap-4">
			{!relationId && (
				<PaymentSentSearch filters={filters} onSearch={setFilters} />
			)}
			<PaymentSentTable filters={filters} relationId={relationId} />
		</div>
	);
}

export default PaymentSent;
